import React from 'react'
import PropTypes from 'prop-types'

import { SERVICE_LABEL_WHOLESALER } from '../Helper/constants.js'

import {
  getSubscribedLiteratureForFunds,
  getWholesalerLabel,
} from '../Helper/helper.js'

function FundListItem({
  fund,
  wholesalerLabels,
  userSubscriptionProfile,
  handleUnsubscribeFund,
  handleManageFundClick,
}) {
  const subscribedLiteratureDocs = getSubscribedLiteratureForFunds(fund)
  const literatureDocs = fund.activeLiterature

  return (
    subscribedLiteratureDocs.length > 0 &&
    literatureDocs.length > 0 && (
      <div className="u-marginBottom3gu">
        <h4>
          {fund.name}
          <span className="u-sm-block">
            <button
              data-fund-id={fund.id}
              onClick={handleUnsubscribeFund}
              className="Link u-marginLeft2gu u-padding0 u-sm-marginLeft0 u-textSecondary u-textKernDefault"
              data-analytics="cesc-unsubscribe-one"
            >
              Unsubscribe
            </button>
            &nbsp;
            <span className="u-textColorLight u-textNormal">|</span>&nbsp;
            <button
              data-fund-id={fund.id}
              onClick={handleManageFundClick}
              className="u-sm-hidden u-md-hidden Link u-padding0 u-textSecondary u-textKernDefault"
            >
              Manage
            </button>
            <button
              data-fund-id={fund.id}
              onClick={handleManageFundClick}
              className="u-lg-hidden Link u-padding0 u-textSecondary"
            >
              Manage
            </button>
          </span>
        </h4>
        <div className="Content">
          {subscribedLiteratureDocs.map((doc, index) => {
            const wholesalerLabel = getWholesalerLabel(
              wholesalerLabels,
              doc.wholesalerLabel
            )
            return (
              <React.Fragment key={'yourSubscriptionDocs' + doc.id}>
                {doc.name}
                {userSubscriptionProfile.role === SERVICE_LABEL_WHOLESALER &&
                  doc.wholesalerLabel &&
                  wholesalerLabel && (
                    <div className="From-you u-marginBottom2gu u-marginLeft1gu u-inlineBlock u-bgColorLight u-paddingHoriz2gu u-textNormal">
                      <div className="u-textSizeMsrm1">{wholesalerLabel}</div>
                    </div>
                  )}
                {index < subscribedLiteratureDocs.length - 1 ? ', ' : ''}
              </React.Fragment>
            )
          })}
        </div>
      </div>
    )
  )
}

FundListItem.propTypes = {
  fund: PropTypes.object.isRequired,
  wholesalerLabels: PropTypes.array.isRequired,
  userSubscriptionProfile: PropTypes.object.isRequired,
  handleUnsubscribeFund: PropTypes.func.isRequired,
  handleManageFundClick: PropTypes.func.isRequired,
}

export default FundListItem
